function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.5 17A8.5 8.5 0 1117 8.5 8.51 8.51 0 018.5 17zM3.64 5.92a5.5 5.5 0 007.44 7.44zm2.08-2.17l7.53 7.53a5.51 5.51 0 00-7.53-7.53z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 2a6.52 6.52 0 00-4.31 1.63l9.18 9.18A6.5 6.5 0 008.5 2zm-5 2.35a6.5 6.5 0 009.15 9.15zM8.5 1A7.5 7.5 0 111 8.5 7.5 7.5 0 018.5 1z",
  fill: "#d34646",
  fillRule: "evenodd"
})))));